import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback, Question2Choice,WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux" 
import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate" 

import { ISOToDateFormat } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";

import * as Alert from "alertService"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import Autocomplete from "components/Autocomplete/Select.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel"; 
import Chip from '@material-ui/core/Chip';
// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";
import Check from "@material-ui/icons/Check";
import RedoIcon from '@material-ui/icons/Redo';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Grid from '@material-ui/core/Grid';
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';

import Switch from "@material-ui/core/Switch"
 
import Table from 'components/Table/Table'; 

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  },
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
const leadStatusKey = {
  1:"ยังไม่เคยเข้าลิงค์",
  2:"ทำไม่ครบ",
  // 3:"ไม่ผ่าน QC"
}

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      
      currentSettingId: [],
      dataListSetting: [],
      tabsIndex:0,
      dataOwnerLead:[],
      dataSelectedFromOwnerLeadIndex:[],
      dataSelectedFromOwnerLead:[],
      dataTableSelectLeadForShow:[],
      dataSelectedLeadForTranfer:[],
      dataSelectedLeadForTranferTotal:0,
      dataSelectedAgentsDestination:[],
      countLeadSelectedByAgent:{},

      dataDealer:[],
      currentBranchName: [],

      status1Checked:true, //>> ยังไม่เคยเข้าลิงค์
      status2Checked:true, //>> ทำไม่ครบ
      status3Checked:true, //>> ไม่ผ่าน QC
      total1Checked:0, 
      total2Checked:0, 
      total3Checked:0,

      totalDataLeadShow:0
    }
  } 

  componentDidMount(){ 
    Alert.Loading(true)
    this.loadSettingDataList(()=>{
      this.loadDealerDataList(() => {
        Alert.LoadingClose()
      })
    }) 
  }
  loadDealerDataList = (callback) => {
    APIPost(UrlServer.URL_POST_GET_DEALER, {dealer_code: undefined}, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "dealer_code",
          newKey: "value"
        },
        {
          oldKey: "branch_name",
          newKey: "label"
        }
      ]
      )
      this.setState({
        dataDealer: newConvertDatas
      }, () => { 
          callback() 
      });
    })
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        no: key + 1, 
        description: CData.description, 
        Count:  CData.Count,
        actions: (
          <div className={"actions-right "+this.props.classes.buttonTable}>
          </div>
        )
      }
    })
  }
  loadSettingDataList = (callback)=>{ 
    APIPost( UrlServer.URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST,{},({datas})=>{  
      var newConvertDatas = arrayObject(datas,[
          {
            oldKey:"_id",
            newKey:"value"
          },
          {
            oldKey:"description",
            newKey:"label"
          },
          {
            oldKey:"created_date_iso",
            newKey:"created_date_iso"
          },
          {
            oldKey:"total_leads",
            newKey:"total_leads"
          }
        ]
      )
      newConvertDatas.map((data,index)=>{ 
        newConvertDatas[index]["name"] = data["name"] + " : " + ISOToDateYMDAndFullTime(data["created_date_iso"])
      })
      this.setState({  
          dataListSetting:newConvertDatas
        },()=>{ 
          callback()
        }); 
    })  
  }
  handleChangeIndex = (key,value) => {  
    this.setState({ [key]:value });
  };  
  loadDataLead = ()=> {
    Alert.Loading() 
    var lead_setting_id = []
    this.state.currentSettingId.map((data)=>{
      lead_setting_id.push(data.value)
    })
    var branch_name = []
    this.state.currentBranchName.map((data)=>{
      branch_name.push(data.value)
    })
    APIPost( UrlServer.URL_POST_GET_DATA_LEAD_FOR_TRANFER,{lead_setting_id:lead_setting_id,branch_name:branch_name},({datas})=>{ 
      this.setState({
        dataOwnerLead:[],
      },()=>{
        this.setState({
          dataOwnerLead:datas, 
        },()=>{
          this.setState({
            dataSelectedFromOwnerLead:[],
            dataSelectedFromOwnerLeadIndex:[],
            total1Checked:0,
            total2Checked:0,
            total3Checked:0,
            dataSelectedLeadForTranfer:[],
            dataSelectedAgentsDestination:[]
          },()=>{
            this.generateRowOfTableSelectLead([],false,()=>{
              this.calculateAddByAgent()
            })
            Alert.LoadingClose() 
          })
        })
      })
    }) 
  }
  handleToggleOwnerLeadQuestion = (data,index,status) => {  
    if(status){
      Question2Choice("คุณต้องการให้ Check Box ของ Lead ที่อยู่ในรายการนี้ ตั้งค่าตั้งต้นเป็นค่า เลือก หรือ ไม่เลือก? ไม่กดปุ่ม","เลือกทั้งหมด" ,"ไม่เลือกทั้งหมด",()=>{
        this.handleToggleOwnerLead(data,index,status,true)
      },()=>{
        this.handleToggleOwnerLead(data,index,status,false)
      })
    }else{
      this.handleToggleOwnerLead(data,index,status,false)
    }
  }
  handleToggleOwnerLead = (data,index,status,status_question) => {   
    if(data.data_lead && data.data_lead.length > 0 ){ 
      Alert.Loading(true)
      setTimeout(() => {
        if(status){
          const new_data = [...this.state.dataSelectedFromOwnerLead,...data.data_lead]   
          var ar_in = this.state.dataSelectedFromOwnerLeadIndex
          ar_in.push(index) 
          this.setState({
            dataSelectedFromOwnerLead:new_data,
            dataSelectedFromOwnerLeadIndex:ar_in
          },()=>{ 
            //count total per type
            var countType1 = 0
            var countType2 = 0
            var countType3 = 0 
            new_data.map((data_lead,index)=>{ 
              switch (data_lead.lead_status) {
                case 1:
                  countType1++
                  break; 
                case 2:
                  countType2++
                  break; 
                case 3:
                  countType3++
                  break; 
              }
            })
            this.setState({
              total1Checked:countType1,
              total2Checked:countType2,
              total3Checked:countType3,
              dataSelectedLeadForTranfer:[], 
              dataTableSelectLeadForShow:[],
              dataSelectedLeadForTranferTotal:0, 
            },()=>{ 
              this.generateRowOfTableSelectLead(new_data,status_question,()=>{
                this.calculateAddByAgent()
              })
              Alert.LoadingClose() 
            }) 
          })
        }else{
          var new_data = []
          var _index =  this.state.dataSelectedFromOwnerLeadIndex.indexOf(index);
          var ar_in = this.state.dataSelectedFromOwnerLeadIndex
          ar_in.splice(_index, 1) 
          ar_in.map((_index)=>{
            var a = (this.state.dataOwnerLead[_index].data_lead)?this.state.dataOwnerLead[_index].data_lead:[]
            new_data = [...new_data,...a] 
          })  
          this.setState({
            dataSelectedFromOwnerLead:new_data,
            dataSelectedFromOwnerLeadIndex:ar_in
          },()=>{ 
            //count total per type
            var countType1 = 0
            var countType2 = 0
            var countType3 = 0 
            new_data.map((data_lead,index)=>{ 
              switch (data_lead.lead_status) {
                case 1:
                  countType1++
                  break; 
                case 2:
                  countType2++
                  break; 
                case 3:
                  countType3++
                  break; 
              }
            })
            this.setState({
              total1Checked:countType1,
              total2Checked:countType2,
              total3Checked:countType3,
              dataSelectedLeadForTranfer:[],
              dataTableSelectLeadForShow:[],
              dataSelectedLeadForTranferTotal:0, 
            },()=>{ 
              this.generateRowOfTableSelectLead(new_data,status_question,()=>{
                this.calculateAddByAgent()
              })
              Alert.LoadingClose() 
            })
          })
        } 
      }, 200);
      
    }
  }
  handleToggle = (key,checked) => { 
    this.setState({
      [key]:checked
    },()=>{
      // if(checked){
        Question2Choice("คุณต้องการให้ Check Box ของ Lead ที่อยู่ในรายการนี้ ตั้งค่าตั้งต้นเป็นค่า เลือก หรือ ไม่เลือก? ไม่กดปุ่ม","เลือกทั้งหมด" ,"ไม่เลือกทั้งหมด",()=>{
          this.generateRowOfTableSelectLead(this.state.dataSelectedFromOwnerLead,true,()=>{
            this.calculateAddByAgent()
          })
        },()=>{
          this.generateRowOfTableSelectLead(this.state.dataSelectedFromOwnerLead,false,()=>{
            this.calculateAddByAgent()
          })
        }) 
      // }  
    })
  }
  handleToggleAgentsDestinationTranfer = (data,checked) => { 
    const c_data = data
    var cur_data_selecte = this.state.dataSelectedAgentsDestination
    if(checked){
      //>>>> add <<<<< 
        cur_data_selecte[c_data._id] = c_data
    }else{
      //>>>> remove <<<<<
        delete cur_data_selecte[c_data._id]
    } 
    this.setState({
      dataSelectedAgentsDestination:cur_data_selecte, 
    },()=>{  
      this.calculateAddByAgent()
    })
  }

  calculateAddByAgent = ()=>{ 
    var curDataSelecte = this.state.dataSelectedAgentsDestination
    //>>>> calculate add by agent <<<<
    var count_lead_selected_by_agent = {}
    var id_arr = []
    for (const key in curDataSelecte) {
      if (curDataSelecte.hasOwnProperty(key)) {
        const el_1 = curDataSelecte[key];
        id_arr.push(el_1._id)
      }
    } 
    const data_loop = this.state.dataSelectedLeadForTranfer
    const length_split = id_arr.length 
    var count_loop = 0
    for (const key in data_loop) {
      if (data_loop.hasOwnProperty(key)) {
        const el = data_loop[key];  
        const cur_id = id_arr[(count_loop % length_split)] 
        if(!count_lead_selected_by_agent[cur_id])count_lead_selected_by_agent[cur_id] = []
        count_lead_selected_by_agent[cur_id].push(el) 
        count_loop++
      }
    }   
    this.setState({ 
      countLeadSelectedByAgent:count_lead_selected_by_agent
    } )
  }

  handleToggleLeadTranfer = (index,checked) => { 
    const c_data = this.state.dataSelectedFromOwnerLead[index]
    var cur_data_selecte = this.state.dataSelectedLeadForTranfer
    var cur_data_selecte_total = this.state.dataSelectedLeadForTranferTotal
    if(checked){
      //>>>> add <<<<< 
      cur_data_selecte[c_data._id] = c_data
      cur_data_selecte_total ++
    }else{
      //>>>> remove <<<<<
      delete cur_data_selecte[c_data._id]
      cur_data_selecte_total --
    } 
    this.setState({
      dataSelectedLeadForTranferTotal:cur_data_selecte_total,
      dataSelectedLeadForTranfer:cur_data_selecte, 
    },()=>{this.calculateAddByAgent()})

  }
  generateRowOfTableOwnerLead = (datas)=>{
    return datas.map((data,index)=>{ 
      return [
        <Checkbox
          className={this.props.classes.positionAbsolute}
          defaultValue ={false}
          tabIndex={-1} 
          onClick={(e) => this.handleToggleOwnerLeadQuestion(data,index,e.target.checked)}
          checkedIcon={<Check className={this.props.classes.checkedIcon} />}
          icon={<Check className={this.props.classes.uncheckedIcon} />}
          classes={{
            checked: this.props.classes.checked
          }}
        />,
        <div className="nwp">{(data.user_data_id)?data.user_data_id.first_name + " " + data.user_data_id.last_name:""}</div>, 
        <Chip size="small" color={data.user_type_code == 5?"secondary":"primary"} label={(data.user_type)?data.user_type:"-"}/>,
        (data.data_lead)?data.data_lead.length:0
      ]
    })
  }
  generateRowOfTableLeadDestination = (datas)=>{
    return datas.map((data,index)=>{ 
      return [
        <Checkbox
          className={this.props.classes.positionAbsolute}
          tabIndex={-1}
          onClick={(e) => this.handleToggleAgentsDestinationTranfer(data,e.target.checked)} 
          checkedIcon={<Check className={this.props.classes.checkedIcon} />}
          icon={<Check className={this.props.classes.uncheckedIcon} />}
          classes={{
            checked: this.props.classes.checked
          }}
        />,
        <div className="nwp">{(data.user_data_id)?data.user_data_id.first_name + " " + data.user_data_id.last_name:""}</div>, 
        <Chip size="small" color={data.user_type_code == 5?"secondary":"primary"} label={((data.data_lead)?data.data_lead.length:0) + ((this.state.countLeadSelectedByAgent[data._id])?" (+"+this.state.countLeadSelectedByAgent[data._id].length+")":"")}/>,
        // <Chip size="small" color={data.user_type_code == 5?"secondary":"primary"} label={(data.user_type)?data.user_type:"-"}/>,
        // ((data.data_lead)?data.data_lead.length:0) + ((true)?" (+0)":"")
      ]
    })
  }
  generateRowOfTableSelectLead = (data,status_question,callback) => {  
    var showData = []
    var cur_data_selecte = {}
    var cur_data_selecte_total = 0
    data.map((CData, key) => {
      if( 
        CData.lead_status &&
        (
          (CData.lead_status === 1 && this.state.status1Checked) ||
          (CData.lead_status === 2 && this.state.status2Checked) ||
          (CData.lead_status === 3 && this.state.status3Checked)
        )
      ){
        showData.push(CData)
        if(status_question){
          cur_data_selecte[CData._id] = CData
          cur_data_selecte_total++ 
        } 
      }
    })  
    var dataTable = showData.map((CData, key) => {  
      var data_lead = CData.data?JSON.parse(CData.data):{} 
      return {
        no: (key + 1), 
        checkbox:<Checkbox
          className={this.props.classes.positionAbsolute}
          // tabIndex={0} 
          defaultChecked={status_question}
          onClick={(e) => this.handleToggleLeadTranfer(key,e.target.checked)}
          checkedIcon={<Check className={this.props.classes.checkedIcon} />}
          icon={<Check className={this.props.classes.uncheckedIcon} />}
          classes={{
            checked: this.props.classes.checked
          }}
        />, 
        dealer_Name : data_lead.Dealer_NameEN+" ("+data_lead.Branch_NameEN+")",
        fname : CData.first_name,
        lname : CData.last_name,
        tel : CData.tel.substr(0,7)+"XXX",
        //fullname : CData.first_name + " " + CData.last_name,
        lead_status : (CData.lead_status)?leadStatusKey[CData.lead_status]:"-",
        call_status : (CData.last_call_status)?CData.last_call_status.description:"-",
        call_sub_status : (CData.last_call_substatus)?CData.last_call_substatus.description:"-",
        call_note : (CData.last_call_note)?CData.last_call_note:"-",
        ac:  "" 
      }
    })  
    this.setState({
      totalDataLeadShow:(data.length - showData.length),
      dataTableSelectLeadForShow:dataTable,
      dataSelectedLeadForTranfer:cur_data_selecte,
      dataSelectedLeadForTranferTotal:cur_data_selecte_total,
    },()=>{
      if(callback)callback()
    })  
  } 
  handleSearch = () => { 
    if(this.state.currentSettingId.length == 0){
      WarningCallback("กรุณาเลือกข้อมูลที่นำเข้า",()=>{  })
      return 
    }   
    // if(this.state.currentBranchName.length == 0){
    //   WarningCallback("กรุณาเลือกสาขา",()=>{  })
    //   return 
    // }   
    this.loadDataLead()
  }
  handleTranferLeadSelected = () => {
    var ad = this.state.dataSelectedAgentsDestination
    var c_ad = 0
    for (const key in ad) {
      if (ad.hasOwnProperty(key)) {
        const el = ad[key];
        c_ad++
      }
    }
    if(c_ad <= 0){
      Alert.WarningCallback("ยังไม่เลือก Agent ปลายทาง")
      return
    }else if(this.state.dataSelectedLeadForTranferTotal <= 0){
      Alert.WarningCallback("ไม่มี Lead ที่ต้องการโอนย้าย")
      return
    }
    Alert.QuestionCallback("ยืนยันการย้าย Lead?", "blue", () => {
      Alert.Loading() 
      var tranferToOwner = {}
      for (const key in this.state.countLeadSelectedByAgent) {
        if (this.state.countLeadSelectedByAgent.hasOwnProperty(key)) {
          // const element = this.state.countLeadSelectedByAgent[key];
          tranferToOwner[key] = []
          var data_in = []
          this.state.countLeadSelectedByAgent[key].map((data_loop)=>{
            data_in.push(data_loop._id)
          })
          tranferToOwner[key] = data_in  
        }
      } 
      var loop_max = 0
      for (const owner_id in tranferToOwner) {
        if (tranferToOwner.hasOwnProperty(owner_id)) {
            const element = tranferToOwner[owner_id];
            loop_max += element.length 
        }
    } 
      var data_for_send = { 
        tranferToOwner:tranferToOwner,
        maxloop:loop_max,
      }
      APIPost( UrlServer.URL_POST_TRANFER_LEAD,data_for_send,({datas})=>{ 
        this.loadDataLead("currentSettingId",this.state.currentSettingId)
      })  
    })
  }
  handleChangeAutoComplete = name => value => {   
    this.setState({
      [name] : value,
    });
  };
  render() {
    const { classes } = this.props
    return (
      <GridContainer> 
        <GridItem xs={12} sm={12} md={12} className={"autocomplete-space"}> 
          {
            (this.state.dataListSetting.length > 0) ? 
            <Autocomplete
              handleChange={this.handleChangeAutoComplete}
              value={this.state.currentSettingId}
              dataList={this.state.dataListSetting}
              id ="currentSettingId"
              label="เลือกข้อมูลที่นำเข้า"
              multi
            />
            : ""
          } 
        </GridItem>
        <GridItem xs={12} sm={12} md={12} className={"autocomplete-space"}>
            {
              (this.state.dataDealer.length > 0) ? 
              <Autocomplete
                handleChange={this.handleChangeAutoComplete}
                value={this.state.currentBranchName}
                dataList={this.state.dataDealer}
                id ="currentBranchName"
                label="เลือกสาขา"
                multi
              />
              : ""
            }
        </GridItem>
        <GridItem xs={12}> 
            <GridContainer className={classes.mt4}>
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  round
                  color="primary"
                  onClick={this.handleSearch}
                >
                  <SearchIcon className={classes.icons} />
                  ค้นหา
                </Button> 
              </GridItem>
            </GridContainer>
          <hr className={"hr-s"}/>
        </GridItem>
        <GridItem xs={5}>
        <h4>เลือกรายการที่ต้องการแจกรายชื่อ</h4>
              <Table
                striped
                tableHead={[
                  
                  <b></b>,
                  <b>ชื่อ-สกุล</b>,
                  <b className="nwp">ประเภท User</b>,
                  <b className="nwp">จำนวนรายชื่อ</b> 
                ]}
                tableData={this.generateRowOfTableOwnerLead(this.state.dataOwnerLead)}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right
                ]}
                customClassesForCells={[0, 5, 6]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right
                ]}
                customHeadClassesForCells={[0, 5, 6]}
              />
        </GridItem>
        <GridItem xs={3} >
          <div className={classes.root,"assign-status-top"}>
          <div>
              <b>เลือกรายสถานะมี {this.state.dataSelectedFromOwnerLead.length} รายการ</b>
          </div>
              <div> 
                  <Checkbox
                    className={classes.positionAbsolute}
                    tabIndex={-1}
                    checked={this.state.status1Checked}
                    onClick={(e) => this.handleToggle("status1Checked",e.target.checked)}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked
                    }}
                  /> {leadStatusKey[1]} ( {this.state.total1Checked} )
                </div>
                <div>
                  <Checkbox
                    className={classes.positionAbsolute}
                    tabIndex={-1}
                    checked={this.state.status2Checked}
                    onClick={(e) => this.handleToggle("status2Checked",e.target.checked)}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{
                      checked: classes.checked
                    }}
                  /> {leadStatusKey[2]} ( {this.state.total2Checked} )
                </div>
          </div>

          <Button  
            size="sm"
            round
            onClick={() => this.handleTranferLeadSelected() }
            fullWidth
            color="info"
            className="remove btn-assign-top"
          > 
            <div><RedoIcon />ทำการย้ายรายชื่อ</div> 
          </Button>
          {/* <i>*เมื่อเลื่อกรายชื่อเรียบร้อยให้กดปุ่มด้านบน</i> */} 
          
        </GridItem>
        <GridItem xs={4} > 
          <h4>เลือกรายการที่ต้องการรับรายชื่อ</h4>
          <Table
            striped
            tableHead={[
              
              <b></b>,
              <b>ชื่อ-สกุล</b>, 
              <b className="nwp">จำนวนรายชื่อ</b> 
            ]}
            tableData={this.generateRowOfTableLeadDestination(this.state.dataOwnerLead)}
            customCellClasses={[
              classes.center,
              classes.right,
              classes.right
            ]}
            customClassesForCells={[0, 5, 6]}
            customHeadCellClasses={[
              classes.center,
              classes.right,
              classes.right
            ]}
            customHeadClassesForCells={[0, 5, 6]}
          /> 
        </GridItem>  
        <GridItem xs={12}> 
          <hr className={"hr-s"}/>
        </GridItem>  
        <GridItem xs={12}> 
          <div className=" ">
            {/* <Button  
              size="sm"
              round
              onClick={() => this.handleLeadUncheck() }
              // fullWidth
              color="warning"
              className="remove "
            > 
              <div><CancelPresentationIcon />Uncheck การเลือกทุกรายการ</div> 
            </Button>{" "} */}
            <b>เลือกรายคนมี {this.state.dataSelectedFromOwnerLead.length - this.state.totalDataLeadShow} รายการ / เลือก {this.state.dataSelectedLeadForTranferTotal} รายการ</b>
            </div>
            <div className="tranferLeadByPerson">   
              {(this.state.dataTableSelectLeadForShow.length > 0)?
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataTableSelectLeadForShow}
                  filterable
                  columns={[
                    {
                      Header: "#",
                      accessor: "no",
                      width:40
                    },
                    {
                      Header: "เลือก",
                      accessor: "checkbox",
                      sortable: false,
                      filterable: false,
                      width:50
                    },
                    {
                      Header: "สาขา",
                      accessor: "dealer_Name",
                      width:200
                    },
                    {
                      Header: "ชื่อ",
                      accessor: "fname",
                      // width:100
                    },
                    {
                      Header: "นามสกุล",
                      accessor: "lname",
                      // width:100
                    },
                    {
                      Header: "โทร-สถานะ",
                      accessor: "call_status", 
                    },
                    {
                      Header: "โทร-สถานะย่อย",
                      accessor: "call_sub_status", 
                    },
                    {
                      Header: "โทร-บันทึก",
                      accessor: "call_note", 
                    },
                    {
                      Header: "เบอร์โทรศัพท์",
                      accessor: "tel",
                      width:150
                    },
                    {
                      Header: "สถานะ",
                      accessor: "lead_status",
                      width:100
                    },
                    {
                      Header: "",
                      accessor: "ac",
                      width:20,
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={this.state.dataTableSelectLeadForShow.length}
                  showPaginationTop={false}
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              :""}
            </div>
        </GridItem>
      </GridContainer>
    )
  }
} 
export default withStyles(styles)(IndexPage)
